import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { CartEntry } from "../../../library-js/php/cart/CartEntry";
import { TemplatesManager } from "../../../library-js/templates/TemplatesManager";
import { AssetsCart } from "../../js/assets/AssetsCart";
import { CartEntryHandler } from "../../js/cart/CartEntryHandler";
import { Rokojori } from "../../js/Rokojori";


export type CartListItemAction = ( item:Element, entry:CartEntry, wishlist:boolean ) => void;


export class CartList
{
  static readonly type = new ElementType( "cart-list" );
  static readonly wishlist = new ElementAttribute( "wish-list" );
  static readonly item = new ElementType( "cart-item" );

  static readonly image   = new ElementType( "cart-item-image" );
  static readonly label   = new ElementType( "cart-item-label" );
  static readonly details = new ElementType( "cart-item-details" );
  static readonly amount  = new ElementType( "cart-item-amount" );
  static readonly price   = new ElementType( "cart-item-price" );
  static readonly tax     = new ElementType( "cart-item-tax" );

  static readonly itemButton = new ElementType( "cart-item-button" );
  static readonly add        = new ClassFlag( "add" );
  static readonly remove     = new ClassFlag( "remove" );

  static readonly removal    = new ElementType( "cart-item-removal" );


  static templatesManager:TemplatesManager;
  static wishlistElements:HTMLElement[] = [];
  static productElements:HTMLElement[] = [];

  static updateAction:CartListItemAction;

  static cart:AssetsCart;

  static applyOnDocument( cart:AssetsCart, templatesManager:TemplatesManager )
  {
    let handler = new CartEntryHandler();

    CartList.updateAction = handler.processEntry;
    CartList.updateCart( cart );
    
    
    CartList.templatesManager = templatesManager;

    CartList.productElements  = CartList.type.queryAll( document ) as HTMLElement[];
    CartList.wishlistElements = CartList.wishlist.queryAll( document ) as HTMLElement[];

    CartList.loadProducts();
    CartList.loadWishlists();
  }

  static async loadProducts()
  {
    let products = await Rokojori.$.assetManagerServer.getCartEntries( false );

    
    CartList.updateItems( CartList.productElements, products, false );
  }

  static async loadWishlists()
  {
    let wishlist = await Rokojori.$.assetManagerServer.getCartEntries( true );
    CartList.updateItems( CartList.wishlistElements, wishlist, true );
  }

  static updateCart( cart:AssetsCart )
  {
    if ( cart == CartList.cart )
    {
      return;
    }

    CartList.cart = cart;

    cart.onChanged.addListener( 
      ()=>
      {
        CartList.loadProducts();
        CartList.loadWishlists();
      }
    );    
  }

  static updateItems( elements:HTMLElement[], entries:CartEntry[], isWishlist:boolean )
  {
    elements.forEach( e => this.setItems( e, entries, isWishlist ) )
  }

  static setItems( e:Element, items:CartEntry[], isWishlist:boolean )
  {
    console.log( "setItems:", items );

    e.innerHTML = "";
    items.forEach(
      ( item )=>
      {
        let itemElement = CartList.templatesManager.createTemplate( CartList.item.type );


        //CartList.label.setText( itemElement, item.id );
        CartList.amount.setText( itemElement, item.amount + "" );       

        
        if ( CartList.updateAction )
        {
          CartList.updateAction( itemElement, item, isWishlist );
        }

        e.appendChild( itemElement );

        /*let removalElement = CartList.removal.query( itemElement );

        if ( removalElement == null )
        {
          console.log( "No removal element", itemElement );

        }

        let attribute = isWishlist ? CartItemRemover.removeFromCart : CartItemRemover.removeFromWishlist;
        
        attribute.to( removalElement, item.id );

        if ( isWishlist )
        {
          CartItemRemover.applyOnElement( removalElement, CartList.cart, true );
        }
        else
        {
          CartItemRemover.applyOnElement( removalElement, CartList.cart, false );
        }
        */
        
        
      }
    )
  }
}